<template>
  <div class="bonusManagePage">
    <div class="wrap">
      <van-cell-group class="baseNone baseSalary">
        <van-field
          :value="mode == 'add' ? userinfo.realName : baseInput.applicantIdName"
          class="ggInput"
          input-align="right"
          readonly
          label="申请人："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseInput.applyTime"
          label="申请日期："
          readonly
          class="ggInput"
          input-align="right"
        />
      </van-cell-group>
      <van-cell-group class="itemSite baseNone beizhu moreText">
        <van-field
          v-model="baseInput.typeName"
          :required="editType"
          label="申请奖金类型："
          placeholder="请选择"
          :is-link="editType"
          @click="showJjType"
          readonly
          input-align="right"
        />
      </van-cell-group>
      <van-cell-group class="itemSite baseNone beizhu">
        <van-field
          v-model="baseInput.projectName"
          :required="editType"
          label="项目名称："
          placeholder="请选择"
          :is-link="editType"
          @click="selectProject"
          readonly
          type="textarea"
          rows="1"
          autosize
          input-align="right"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseInput.projectCode"
          label="项目编号："
          readonly
          class="ggInput"
          input-align="right"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          v-model="baseInput.contractAmount"
          label="合同金额(元)："
          readonly
          class="ggInput"
          input-align="right"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          v-model="baseInput.dzAmount"
          label="到账金额(元)："
          readonly
          class="ggInput"
          input-align="right"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseInput.cooperationAmount"
          label="商务费(元)："
          readonly
          class="ggInput"
          input-align="right"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          v-model="baseInput.marketingCostTotal"
          label="营销成本(元)："
          readonly
          class="ggInput"
          input-align="right"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          v-model="baseInput.technicalCostTotal"
          label="技术成本(元)："
          readonly
          class="ggInput"
          input-align="right"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          v-model="baseInput.bidCostTotal"
          label="投标成本(元)："
          readonly
          class="ggInput"
          input-align="right"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          v-model="baseInput.effectiveAmount"
          label="有效产值(元)："
          readonly
          class="ggInput"
          input-align="right"
        />
      </van-cell-group>
      <van-cell-group
        class="baseNone baseSalary moreText"
        v-if="baseInput.type == 'js'"
      >
        <van-field
          v-model="baseInput.qualityCoefficient"
          readonly
          type="number"
          label="成果质量系数(%)："
          class="ggInput"
          input-align="right"
        />
        <p
          v-if="Number(baseInput.qualityCoefficient) <= 0"
          class="totalRule red"
        >
          请提交项目内审结果
        </p>
      </van-cell-group>
      <van-cell-group
        class="baseNone baseSalary moreText"
        v-if="baseInput.type == 'js'"
      >
        <van-field
          v-model="baseInput.targetCoefficient"
          label="全年完成产值初定系数(%)："
          :required="editType"
          readonly
          class="ggInput"
          input-align="right"
        />
      </van-cell-group>

      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          v-model="baseInput.provisionPercent"
          type="number"
          :label="
            baseInput.type == 'yx'
              ? '营销计提比例(%)：'
              : baseInput.type == 'js'
              ? '技术计提比例(%)：'
              : '计提比例(%)：'
          "
          :required="editType"
          :readonly="baseInput.type == 'js'"
          class="ggInput"
          input-align="right"
          @input="getBonus"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          v-model="baseInput.provisionCoefficient"
          label="计提系数(%)："
          readonly
          class="ggInput"
          input-align="right"
        />
        <p class="totalRule">计提系数本年度为50%,往年为100%</p>
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          v-model="baseInput.estimateBonus"
          label="预估计提奖金(元)："
          readonly
          class="ggInput"
          input-align="right"
        />
        <p v-if="baseInput.type == 'yx'" class="totalRule">
          计提奖金=有效产值*营销计提比例-营销成本-50%*投标成本
        </p>
        <p v-if="baseInput.type == 'js'" class="totalRule">
          计提奖金=有效产值*全年目标产值完成
          初定系数*成果质量系数*技术计提比例-技术成本-50%投标成本
        </p>
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          v-model="baseInput.grantBonus"
          label="本次发放奖金(元)："
          readonly
          class="ggInput"
          input-align="right"
        />
        <p class="totalRule">
          本次发放奖金=计提奖金*(计提系数本年度为50%,往年为100%)
        </p>
      </van-cell-group>
      <van-cell-group
        class="baseNone baseSalary moreText"
        v-if="baseInput.type == 'js'"
      >
        <van-field
          v-model="jsReward"
          label="本次需发放奖金(元)："
          readonly
          class="ggInput"
          input-align="right"
        />
      </van-cell-group>

      <van-cell-group
        class="baseNone baseSalary moreText"
        v-if="baseInput.type == 'js'"
      >
        <van-field
          v-model="baseInput.settlementBonus"
          label="计提奖金结算额(元)："
          :required="editType"
          readonly
          class="ggInput"
          input-align="right"
          type="number"
        />
      </van-cell-group>
      <van-cell-group
        class="baseNone baseSalary moreText"
        v-if="baseInput.type == 'js'"
      >
        <van-field
          v-model="remainingBonus"
          label="剩余奖金(元)："
          readonly
          type="number"
          class="ggInput"
          input-align="right"
        />
      </van-cell-group>
      <!-- 奖金分配明细 -->
      <div class="claimDetailMain">
        <p class="fgx"></p>
        <p class="tit">奖金分配明细</p>
        <van-cell-group class="claimDetailBox" v-if="baseInput.type == 'yx'">
          <div class="claimDetailLists">
            <div
              class="claimItem"
              v-for="(item, index) in bonusList"
              :key="index"
            >
              <van-cell-group class="baseNone baseSalary beizhu">
                <van-field
                  v-model="item.realName"
                  label="人员："
                  readonly
                  class="ggInput"
                  input-align="right"
                  required
                />
              </van-cell-group>

              <van-cell-group class="baseNone baseSalary beizhu">
                <van-field
                  v-model="item.actualReward"
                  clearable
                  readonly
                  class="ggInput"
                  input-align="right"
                  label="奖金金额："
                  required
                />
              </van-cell-group>

              <!-- <div class="delect" v-if="bonusList.length > 1 && editType">
                <van-icon name="cross" @click="delect(index)" />
              </div> -->
            </div>
          </div>
          <!-- <div class="addBtn" v-if="editType">
            <van-button
              icon="plus"
              type="primary"
              class="addClaim"
              size="small"
              @click="addClaim"
              >添加奖金分配明细</van-button
            >
          </div> -->
        </van-cell-group>
        <van-cell-group class="claimDetailBox" v-else>
          <div class="claimDetailLists">
            <div
              class="claimItem"
              v-for="(item, index) in bonusList"
              :key="index"
            >
              <van-cell-group class="baseNone baseSalary beizhu">
                <van-field
                  v-model="item.userName"
                  label="人员："
                  readonly
                  class="ggInput"
                  input-align="right"
                />
              </van-cell-group>
              <van-cell-group class="baseNone baseSalary beizhu">
                <van-field
                  v-model="item.positionName"
                  label="项目岗位："
                  readonly
                  class="ggInput"
                  input-align="right"
                />
              </van-cell-group>
              <van-cell-group class="baseNone baseSalary beizhu">
                <van-field
                  v-model="item.deptName"
                  label="所属部门："
                  readonly
                  class="ggInput"
                  input-align="right"
                />
              </van-cell-group>
              <van-cell-group class="baseNone baseSalary beizhu">
                <van-field
                  v-model="item.distributionProportion"
                  label="分配比例："
                  readonly
                  class="ggInput"
                  input-align="right"
                />
              </van-cell-group>
              <van-cell-group class="baseNone baseSalary moreText">
                <van-field
                  v-model="item.grade"
                  label="考核系数(%)："
                  readonly
                  class="ggInput"
                  input-align="right"
                />
              </van-cell-group>
              <van-cell-group class="baseNone baseSalary moreText">
                <van-field
                  v-model="item.reward"
                  label="预估奖金(元)："
                  readonly
                  class="ggInput"
                  input-align="right"
                />
              </van-cell-group>
              <van-cell-group class="baseNone baseSalary moreText">
                <van-field
                  v-model="item.actualReward"
                  clearable
                  type="number"
                  v-enterIntNumber
                  :required="editType"
                  :readonly="!editType"
                  class="ggInput"
                  input-align="right"
                  label="实发奖金金额(元)："
                  @input="amountJsTotal(index, item)"
                  :placeholder="editType ? '请输入...  ' : ''"
                />
              </van-cell-group>
            </div>
          </div>
          <div class="addBtn" v-if="editType && baseInput.type == 'yx'">
            <van-button
              icon="plus"
              type="primary"
              class="addClaim"
              size="small"
              @click="addClaim"
              >添加奖金分配明细</van-button
            >
          </div>
        </van-cell-group>
      </div>

      <!-- 附件 现在去掉-->

      <!-- 审批流程 -->
      <div
        class="approveList"
        v-if="this.mode != 'add' && baseInput.verifyStatus != 'hold'"
      >
        <audit-list :applicantData="baseInput"></audit-list>
      </div>

      <!-- 流程图 -->
      <div
        class="flowList"
        v-if="this.mode != 'add' && baseInput.verifyStatus != 'hold'"
      >
        <flow-staff :applicantData="baseInput"></flow-staff>
        <flow-list :workflowCode="baseInput.workflowCode"></flow-list>
      </div>
      <!-- 审批 -->
      <van-popup
        v-model="verifyPageType"
        closeable
        round
        close-icon="close"
        position="bottom"
        class="verifyPage"
      >
        <verify-main
          :applicantData="baseInput"
          @changeVerifyType="setVerifyType"
        ></verify-main>
      </van-popup>
    </div>
    <!-- 保存按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput"
        class="btn"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="baseInput.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
              class="btn"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput"
              class="btn"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="baseInput.verifyStatus == 'deny'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput"
          class="btn"
          >再次提交</van-button
        >
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        baseInput.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply"
        class="btn"
        >撤回修改</van-button
      >
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          baseInput.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          baseInput.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">{{
        verifyPageText
      }}</van-button>
    </div>
    <!-- 奖金类型 -->
    <van-popup v-model="showJjTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="applyStatusData"
        value-key="dictName"
        @cancel="showJjTypePicker = false"
        @confirm="saveJjType"
      />
    </van-popup>
    <!-- 项目列表 -->
    <van-popup v-model="showProjectMain" position="bottom" class="roleBox">
      <project-view
        :selectTypes="baseInput.type"
        @setItems="setProject"
      ></project-view>
    </van-popup>
    <!-- 选择人员 -->
    <van-popup
      v-model="showRedioRetinuePicker"
      position="bottom"
      class="roleBox"
    >
      <redio-retinue-view @setReview="setRedioRetinue"></redio-retinue-view>
    </van-popup>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { dateFormat } from "@/utils/common";
const projectView = () => import("./components/projectMain");
// const fileView = () => import("@/components/common/fileView");
// const wxFileView = () => import("@/components/common/wxFileView");
const flowList = () => import("@/components/common/flowList");
const auditList = () => import("@/components/common/auditList");
const flowStaff = () => import("@/components/common/flowStaff");
const verifyMain = () => import("@/components/common/verifyMain");
const redioRetinueView = () =>
  import("@/components/businessTripMould/redioRetinueView");
import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
export default {
  name: "bonusManage",
  components: {
    // refreshPage,
    auditList,

    projectView,
    // biddingView,
    flowList,
    verifyMain,
    flowStaff,
    redioRetinueView,
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      mode: "add",
      editType: false, //能否编辑
      commonId: "",
      isCurrentYear: false,
      baseInput: {
        applyTime: "",
        type: "",
        typeName: "",
        projectId: "", //项目id
        projectName: "", //项目名称
        projectCode: "", //项目编号
        contractAmount: "", //合同金额
        dzAmount: "", //到账金额
        cooperationAmount: "", //合作费
        effectiveAmount: "", //有效产值
        marketingCostTotal: "", //营销成本
        technicalCostTotal: "", //技术成本
        bidCostTotal: "", //投标成本
        targetCoefficient: "", //全年完成产值初定系数
        qualityCoefficient: "", //成果质量系数
        provisionPercent: "", //计提比例
        provisionCoefficient: "", //计提系数
        estimateBonus: "", //预估计提奖金
        grantBonus: "", //本次发放奖金
        settlementBonus: "", //计提奖金结算额
        baseAnnexes: [], //附件
        verifyStatus: "hold",
      },

      applyStatusData: [
        {
          dictCode: "yx",
          dictName: "营销",
        },
        {
          dictCode: "js",
          dictName: "技术",
        },
      ],
      showJjTypePicker: false, //奖金类别
      showProjectMain: false, //项目选择
      remainingBonus: "", //剩余奖金
      bonusList: [
        {
          uid: "", //员工id
          userName: "", //员工名称
          position: "", //岗位
          reward: "", //预估奖金
          actualReward: "", //实际发放奖金
          distributionProportion: "", //奖金分配比例
          grade: "", //考核分数
        },
      ], //分配奖金明细
      jsReward: "", //本次需发放奖金
      saveItemType: true,
      selectPeopleIndex: "",
      showRedioRetinuePicker: false, // 项目负责人弹框
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      clientType: getDeviceType(),
      sendType: "", //判断是否在抄送列表
      is_weixn: is_wei(), //是否为微信
    };
  },
  mounted() {
    let time = dateFormat(new Date());
    this.setShowLoad(false);
    if (is_wei()) {
      document.title = "项目奖金申请";
    }
    this.commonId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑
    this.verifyType = this.$route.query.verifyType;
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    this.editType = this.mode == "add" ? true : false;
    window.editPage = this.editPage; //编辑页面
    window.verifyPage = this.verifyPage; //审核页面

    this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";

    if (this.mode == "add") {
      this.setShowLoad(false);
      this.$set(this.baseInput, "applyTime", time);
    } else {
      this.initPage();
    }
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    editPage() {
      //需要编辑
      this.editType = true;
    },
    verifyPage() {
      //审批弹窗
      this.verifyPageType = true;
    },
    // //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    //选择人员
    addClaim() {
      //添加报销明细函数
      this.bonusList.push({
        uid: "", //员工id
        userName: "", //员工名称
        position: "", //岗位
        reward: "", //预估奖金
        actualReward: "", //实际发放奖金
        distributionProportion: "", //奖金分配比例
        grade: "", //考核分数
      });
    },
    delect(index) {
      this.bonusList.splice(index, 1);
    },
    //获取奖金人
    getSelectPeople(index) {
      this.selectPeopleIndex = index;
      this.showRedioRetinuePicker = true;
    },
    /*奖金人回调*/
    setRedioRetinue(result) {
      this.$set(
        this.bonusList[this.selectPeopleIndex],
        "userName",
        result.realName
      );
      this.$set(this.bonusList[this.selectPeopleIndex], "uid", result.id);
      this.$set(this.bonusList[this.selectPeopleIndex], "deptId", result.depId);
      this.showRedioRetinuePicker = false;
    },
    amountTotal() {
      let _this = this;
      let total = "";
      this.bonusList.forEach((item) => {
        if (!isNaN(item.actualReward) && Number(item.actualReward) < 0) {
          _this.$toast("分配奖金必须为数字且大于0");
          return;
        }
        total = Number(item.actualReward) + Number(total);
      });
      if (this.baseInput.type == "yx") {
        if (total > this.baseInput.grantBonus) {
          _this.$toast("分配奖金不能大于本次发放奖金");
        }
      } else {
        if (total > this.baseInput.settlementBonus) {
          _this.$toast("分配奖金不能大于计提奖金结算额");
        }
      }
    },
    //奖金类别
    showJjType() {
      if (this.editType) {
        this.showJjTypePicker = true;
      }
    },
    saveJjType(data) {
      //保存奖金Type
      let _this = this;
      this.showJjTypePicker = false;
      this.$set(this.baseInput, "type", data.dictCode);
      this.$set(this.baseInput, "typeName", data.dictName);
      _this.baseInput.projectName = "";
      _this.baseInput.projectId = "";
      _this.baseInput.bidCostTotal = "";
      _this.baseInput.contractAmount = "";
      _this.baseInput.cooperationAmount = "";
      _this.baseInput.dzAmount = "";
      _this.baseInput.effectiveAmount = "";
      _this.baseInput.marketingCostTotal = "";
      _this.baseInput.projectCode = "";
      _this.baseInput.technicalCostTotal = "";
      _this.baseInput.estimateBonus = "";
      _this.baseInput.grantBonus = "";
      _this.baseInput.settlementBonus = "";
      _this.baseInput.provisionPercent = ""; //计提比例
      _this.baseInput.qualityCoefficient = "";
      _this.baseInput.provisionCoefficient = "";
      if (data.dictCode == "yx") {
        this.bonusList = [
          {
            uid: "", //员工id
            userName: "", //员工名称
            position: "", //岗位
            reward: "", //预估奖金
            actualReward: 0, //实际发放奖金
            distributionProportion: "", //奖金分配比例
            grade: "", //考核分数
          },
        ];
      } else {
        this.bonusList = [];
      }
    },
    //获取项目列表
    selectProject() {
      if (this.editType) {
        if (this.baseInput.type) {
          this.showProjectMain = true;
        } else {
          this.$toast("请先选择奖金类型");
        }
      }
    },
    setProject(data) {
      //保存项目

      //获取所属项目
      let _this = this;
      if (data.projectId) {
        _this.baseInput.projectName = data.projectName;
        _this.baseInput.projectId = data.projectId;
        _this.baseInput.bidCostTotal = data.bidCostTotal;
        _this.baseInput.contractAmount = data.contractAmount;
        _this.baseInput.cooperationAmount = data.cooperationAmount;
        _this.baseInput.dzAmount = data.dzAmount;
        _this.baseInput.effectiveAmount = data.effectiveAmount;
        _this.baseInput.marketingCostTotal = data.marketingCostTotal;
        _this.baseInput.projectCode = data.projectCode;
        _this.baseInput.technicalCostTotal = data.technicalCostTotal;
        _this.baseInput.qualityCoefficient = data.qualityCoefficient;
        _this.isCurrentYear = new Date().getFullYear() == data.projectYear;
        _this.baseInput.targetCoefficient = data.targetCoefficient;
        _this.baseInput.provisionCoefficient = _this.isCurrentYear ? 50 : 100; //本年度为50% 往年度为100%
        if (_this.baseInput.type == "yx") {
          if (data.undertakeList && data.undertakeList[0]) {
            _this.bonusList = [];
            data.undertakeList.forEach((item) => {
              _this.bonusList.push(item);
            });
          }
          if (_this.baseInput.provisionPercent) {
            _this.getBonus();
          }
        } else {
          if (Number(_this.baseInput.qualityCoefficient) <= 0) {
            return;
          }
          _this.getBonusList(data.projectId);
          _this.getJsPercent(data.projectId);

          // if (
          //   _this.baseInput.provisionPercent &&
          //   _this.baseInput.targetCoefficient
          // ) {
          //   _this.getBonus();
          // }
        }
      }
      this.showProjectMain = false;
    },
    //获取技术计提比例
    getJsPercent(projectId) {
      let _this = this;
      _this.$api.administration.administration.bonus
        .percent(projectId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.baseInput.provisionPercent = res.data;
            if (
              _this.baseInput.provisionPercent &&
              _this.baseInput.targetCoefficient
            ) {
              _this.getBonus();
            }
          } else {
            _this.baseInput.provisionPercent = "";
            _this.$toast(res.msg);
          }
        });
    },
    //获取奖金明细
    getBonusList(projectId) {
      let _this = this;
      _this.$api.administration.administration.bonus
        .workloadUids({
          projectId: projectId,
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.bonusList = res.data;
            let rewardTotal = 0;
            if (_this.bonusList[0]) {
              _this.bonusList.forEach((item) => {
                rewardTotal += Number(item.reward);
                // Number(rewardTotal) + Number(item.reward)
              });

              _this.jsReward = parseFloat(rewardTotal).toFixed(2);
            }
          } else {
            _this.bonusList = [];
            _this.$toast(res.msg);
          }
        });
    },
    //技术奖金类型校验
    amountJsTotal(valIndex, data) {
      let _this = this;
      if (_this.baseInput.targetCoefficient) {
        let oldVal = _this.bonusList[valIndex].reward;
        _this.totalMoney();
        if (Number(data.actualReward) > Number(oldVal)) {
          _this.saveItemType = false;
          _this.$toast(data.userName + " 的实际发放金额不能大于预估奖金");
        }
      } else {
        _this.$toast("请先填写全年目标产值完成初定系数!");
      }
    },
    //计算奖金
    getBonus() {
      let _this = this;
      //本次发放奖金（公式：计提奖金*50%）元
      if (
        _this.baseInput.effectiveAmount &&
        _this.baseInput.marketingCostTotal
      ) {
        if (_this.baseInput.type == "yx") {
          //营销计提奖金（公式：有效产值*营销计提比例-营销成本-50%投标成本）元
        
          if (
            _this.baseInput.provisionPercent > 0 &&
            _this.baseInput.provisionPercent <= 100
          ) {
            _this.baseInput.estimateBonus = (
              _this.baseInput.effectiveAmount *
                (_this.baseInput.provisionPercent / 100) -
              _this.baseInput.marketingCostTotal -
              _this.baseInput.bidCostTotal * 0.5
            ).toFixed(2);
            _this.baseInput.grantBonus = (
              _this.baseInput.estimateBonus * (_this.isCurrentYear ? 0.5 : 1)
            ).toFixed(2);
            if (_this.bonusList[0]) {
              _this.bonusList.forEach((item) => {
                item.actualReward = parseFloat(
                  (Number(_this.baseInput.grantBonus) *
                    Number(item.proportion)) /
                    100
                ).toFixed(2);
              });
            }
          } else {
            _this.$toast("计提比例不能小于0 或 大于100!");
          }
        } else {
          if (
            _this.baseInput.targetCoefficient &&
            _this.baseInput.provisionPercent
          ) {
            //技术计提奖金（公式： 计提奖金=有效产值*全年目标产值完成初定系数*成果质量系数*技术计提比例-技术成本-50%投标成本）元
            if (
              _this.baseInput.targetCoefficient > 0 &&
              _this.baseInput.provisionPercent > 0 &&
              _this.baseInput.provisionPercent <= 100
            ) {
              _this.baseInput.estimateBonus = (
                _this.baseInput.effectiveAmount *
                  (_this.baseInput.targetCoefficient / 100) *
                  (_this.baseInput.qualityCoefficient / 100) *
                  (_this.baseInput.provisionPercent / 100) -
                _this.baseInput.technicalCostTotal -
                _this.baseInput.bidCostTotal * 0.5
              ).toFixed(2);
              _this.baseInput.grantBonus = (
                _this.baseInput.estimateBonus * (_this.isCurrentYear ? 0.5 : 1)
              ).toFixed(2);
            } else {
              _this.$toast(
                "全年目标产值完成初定系数、成果质量系数、计提比例不能小于0 或 大于100!"
              );
            }
          }
        }
      } else {
        _this.$toast("请选择项目");
      }
    },
    //技术获取奖金
    // gettlementBonus() {
    //   let _this = this;
    //   if (
    //     _this.baseInput.settlementBonus > 0 &&
    //     Number(_this.baseInput.settlementBonus) <=
    //       Number(_this.baseInput.grantBonus)
    //   ) {
    //     _this.remainingBonus = (
    //       Number(_this.baseInput.estimateBonus) -
    //       Number(_this.baseInput.settlementBonus)
    //     ).toFixed(2);
    //   } else {
    //     _this.$toast("计提奖金不能小于0 或者 大于本次发放奖金");
    //   }
    // },
    //获取计提奖金结算额
    totalMoney() {
      let _this = this,
        total = 0;
      if (_this.bonusList[0]) {
        _this.bonusList.forEach((item) => {
          total += Number(item.actualReward ? item.actualReward : 0);
        });
        _this.baseInput.settlementBonus = parseFloat(total).toFixed(2);
        _this.remainingBonus = parseFloat(
          Number(_this.baseInput.estimateBonus) -
            Number(_this.baseInput.settlementBonus)
        ).toFixed(2);
        if (
          Number(_this.baseInput.settlementBonus) >
          Number(_this.baseInput.grantBonus)
        ) {
          _this.$toast("计提奖金不能小于0 或者 大于本次发放奖金");
        }
      } else {
        _this.settlementBonus = 0;
      }
    },
    initPage() {
      let _this = this;
      _this.bonusList = [];
      _this.$api.administration.administration.bonus
        .details(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.baseInput = Object.assign({}, res.data);
            // _this.bonusList = res.data.allocationList;
            _this.remainingBonus = (
              Number(_this.baseInput.estimateBonus) -
              Number(_this.baseInput.settlementBonus)
            ).toFixed(2);
            _this.baseInput.contactor = res.data.firstContact;
            if (res.data.allocationList[0]) {
              res.data.allocationList.forEach((item) => {
                item.realName = item.userName;
                _this.jsReward = parseFloat(
                  Number(_this.jsReward) + Number(item.reward)
                ).toFixed(2);
                _this.bonusList.push(item)
              });
            }
            if (
              (_this.baseInput.verifyStatus == "hold" ||
                _this.baseInput.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
            
          } else {
            _this.$toast(res.msg);
          }
        });
    },
    // 撤回和删除
    delApply() {
      let _this = this;
      let text = this.baseInput.verifyStatus == "hold" ? "删除" : "撤回";
      this.$dialog
        .alert({
          title: text,
          message: "你确定" + text + "吗?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.administration.administration.bonus
            .deleteRecall(this.baseInput.verifyStatus, _this.baseInput.id)
            .then((res) => {
              if (res.code == "1") {
                let msg = text + "成功";
                closePage(msg);
              } else {
                _this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch(() => {
              _this.btnLoading = false;
              _this.$toast("网络失败，请稍后重试");
            });
        });
    },
    checkInput() {
      let _this = this;
      let total = "";
      this.bonusList.forEach((item) => {
        if (!item.actualReward || !item.uid) {
          _this.$toast("人员或者分配奖金不能为空");
          return;
        }
        if (_this.baseInput.type == "js") {
          if (Number(item.actualReward) > Number(item.reward)) {
            _this.$toast(item.userName + "的实发奖金大于预估预估奖金");
            return;
          }
        }
        total = Number(item.actualReward) + Number(total);
      });
      total = parseFloat(total).toFixed(2);
      if (_this.baseInput.type == "yx") {
        if (_this.baseInput.provisionPercent && _this.baseInput.projectId) {
          if (Number(_this.baseInput.estimateBonus) > 0) {
            //20230210 需求变更 营销奖金--分配奖金之和必须等于本次发放奖金
            if (total == this.baseInput.grantBonus) {
              _this.savePort();
            } else {
              _this.$toast("分配奖金总和必须等于本次发放奖金");
            }
          } else {
            _this.$toast("计提奖金必须大于0!");
          }
        } else {
          _this.$toast("带星号为必填!");
        }
      } else {
        if (
          _this.baseInput.provisionPercent &&
          _this.baseInput.projectId &&
          _this.baseInput.targetCoefficient &&
          _this.baseInput.settlementBonus
        ) {
          if (Number(_this.baseInput.estimateBonus) > 0) {
            //20230210 需求变更 技术奖金--计提奖金结算额必须等于本次发放奖金
            if (
              Number(_this.jsReward) == Number(_this.baseInput.settlementBonus)
            ) {
              if (total > this.baseInput.settlementBonus) {
                _this.$toast("分配奖金不能大于计提奖金结算额");
                return;
              }
              _this.savePort();
            } else {
              _this.$toast("计提奖金结算额必须等于本次需发放奖金!");
            }
          } else {
            _this.$toast("项目奖金必须大于0!");
          }
        } else {
          _this.$toast("带星号为必填!");
        }
      }
    },
    /*保存接口*/
    savePort() {
      let _this = this;
      _this.loading = true;
      _this.baseInput.allocationList = this.bonusList;
      _this.$api.administration.administration.bonus
        .addEditBonus(_this.mode, _this.baseInput)
        .then((res) => {
          _this.loading = false;
          if (res.code == "1") {
            let text = this.mode == "add" ? "添加成功" : "编辑成功";
            closePage(text);
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.loading = false;
          _this.$toast(err);
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
};
</script>
<style lang="less">
.bonusManagePage {
  width: 100%;
  height: 100%;
  background-color: #fff;

  .totalRule {
    font-size: 12px;
    color: #666;
    padding: 0 16px;
  }
  .red {
    color: red;
  }
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 15px;
  }
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.moreText {
    .van-cell {
      .van-cell__title {
        width: 200px;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .dwBox {
    .van-cell {
      .van-cell__title {
        width: 140px;
      }
    }
  }

  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }

  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin-top: 10px;
  }
  .moneyPicker {
    width: 100%;
    height: 90%;

    background-color: #fff;
    .van-popup__close-icon--top-right {
      top: 5px;
      right: 5px;
      color: red;
    }
    ul {
      width: 100%;
      height: 100%;
      overflow-y: scroll;

      padding: 16px 16px 20px 16px;

      li {
        width: 100%;
        padding: 8px 8px;
        margin: 10px 0;
        background-color: #fff;
        border: 1px solid #eeeeee;
        border-radius: 8px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
        .incomeInfo {
          p {
            width: 100%;
            overflow: hidden;
            font-size: 15px;
            line-height: 20px;
            margin: 5px 0;
            color: #333;
          }
        }
      }
    }
    .nonePage {
      width: 120px;
      height: 135px;

      position: absolute;
      left: 50%;
      margin-left: -60px;
      top: 50%;
      margin-top: -67px;
      img {
        display: block;
        max-width: 100px;
        max-height: 100px;
        margin: 0 auto;
      }

      p {
        margin-top: 10px;
        text-align: center;
        color: #5c5d5d;
        font-size: 16px;
      }
    }
  }
  //添加明细样式
  .claimDetailMain {
    background-color: #fff;
    .fgx {
      width: 100%;
      height: 10px;
      background-color: #f6f6f6;
    }
    p.tit {
      position: relative;
      padding: 0 16px 0 25px;
      font-size: 15px;
      height: 45px;
      line-height: 45px;
      position: relative;
      color: #2581d6;
      font-weight: 700;
      border-bottom: 1px solid #f6f6f6;
    }
    p.tit:before {
      content: "";
      position: absolute;
      width: 5px;
      height: 20px;
      background: #2581d6;
      top: 13px;
      left: 16px;
    }
    .baseNone::after {
      content: none;
    }
    .claimDetailBox.van-cell-group.van-hairline--top-bottom::after {
      content: none;
    }
  }
  .claimDetailBox {
    width: 100%;
    padding-bottom: 10px;
    .claimDetailLists {
      width: 95%;
      margin: 0 auto;
      min-height: 140px;
      .claimItem {
        margin-top: 10px;
        border: 1px solid #f1f1f1;
        border-radius: 4px;
        position: relative;
        .delect {
          text-align: center;
          position: absolute;
          top: -6px;
          right: -4px;
          width: 20px;
          height: 20px;
          line-height: 20px;
          border-radius: 50%;
          background: #fff;
          border: 1px solid red;
          color: red;
          cursor: pointer;
          padding-top: 1px;
        }
      }
    }
    .addBtn {
      margin-top: 10px;
      width: 100%;
      .addClaim {
        display: block;
        margin: 0 auto;
        border-radius: 8px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
      }
    }
  }
}
</style>
<style lang="less">
.bonusManagePage {
  .ggInput.van-cell::after {
    content: none;
  }
}
</style>